const getMessageFromUnknown = (
    value: unknown,
    fallbackMessage: string,
): string => {
    if (typeof value === 'string' && value.length > 0) {
        return value;
    }

    if (value != null && typeof value === 'object' && 'message' in value) {
        const { message } = value as { message: unknown };
        if (typeof message === 'string' && message.length > 0) {
            return message;
        }
    }

    return fallbackMessage;
};

export const toError = (
    value: unknown,
    fallbackMessage = 'Unknown error',
): Error => {
    if (value instanceof Error) {
        return value;
    }

    if (value == null) {
        return new Error(fallbackMessage);
    }

    if (typeof value === 'string') {
        return new Error(value);
    }

    const error = new Error(getMessageFromUnknown(value, fallbackMessage));
    error.cause = value;
    return error;
};

export const getErrorMessage = (
    value: unknown,
    fallbackMessage = 'Unknown error',
): string => {
    if (value instanceof Error) {
        return value.message;
    }

    return getMessageFromUnknown(value, fallbackMessage);
};
